import { render } from "./NewMemberRegistration.vue?vue&type=template&id=263c8482&scoped=true"
import script from "./NewMemberRegistration.vue?vue&type=script&lang=js"
export * from "./NewMemberRegistration.vue?vue&type=script&lang=js"

import "./NewMemberRegistration.vue?vue&type=style&index=0&id=263c8482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263c8482"]])

export default __exports__